/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Col_In_StockInputs */

const vi_shop_col_in_stock = /** @type {(inputs: Shop_Col_In_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn hàng`)
};

/**

* @param {Shop_Col_In_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_col_in_stock = /** @type {((inputs?: Shop_Col_In_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Col_In_StockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_col_in_stock(inputs)
});